import React from "react";
import InputCreate from "../../features/InputCreate";
import Button from "../../features/Button";
import { Upload } from "antd";
import { AiFillDelete } from "react-icons/ai";
import { lienImage } from "../../api/api";
// import { MultiSelect } from 'primereact/multiselect';
const styleBtn = {
  padding: ".5em",
  borderRadius: "5px",
  fontWeight: "bold",
  cursor: "pointer",
  color: "black",
  backgroundColor: "rgb(255 177 47 / 99%)",
  marginTop: "1em",
  border: "none",
};

function FormShared({
  dataInfoFormInput,
  dataInfoFormSelect,
  handleSubmit,
  btnTitle,
  isLoading,
  fileList,
  onChangeForGalerie,
  onPreview,
  isUploadPhoto,
  isTextarea,
  dataTextArea,
  galeries,
  deleteImageBiens,
  isDelete,
  isDataGalerie,
  isPasswordModify,
  dataInfoFormInputPasswordModify,
  handleSubmitPassword,
  btnTitleModifyPassword,
  isLoadingBtnForPaswword,
  // dataWithMuliselectPersmission,
  // selectedPermission,
  // setSelectedPermission,
  // allPermission
}) {
  return (
    <>
      <form onSubmit={handleSubmit} className="p-3">
        <div className="row">
          {dataInfoFormInput.map(
            (item, index) =>
              item.dataValue && (
                <InputInfo
                  key={index}
                  labelInput={item.labelInput}
                  isForModifyOrNotModify={item.isForModifyOrNotModify}
                  isApplyValueByDefault={item.isApplyValueByDefault}
                  handleValue={item.handleValue}
                  nameInput={item.nameInput}
                  typeInput={item.typeInput}
                  dataValue={item.dataValue}
                  isDisabledInput={item.isDisabledInput}
                />
              )
          )}
        </div>
        {isTextarea && <DataForTextArea dataTextArea={dataTextArea} />}
        {dataInfoFormSelect.length > 0 && (
          <SelectByOptionData dataInfoFormSelect={dataInfoFormSelect} />
        )}
        {isDataGalerie && (
          <ShowGalerie
            galeries={galeries}
            deleteImageBiens={deleteImageBiens}
            isDelete={isDelete}
          />
        )}

        {isUploadPhoto && (
          <UploadImages
            fileList={fileList}
            onChangeForGalerie={onChangeForGalerie}
            onPreview={onPreview}
          />
        )}
        {isDelete && (
          <Button titre={btnTitle} styleBtn={styleBtn} isLoading={isLoading} />
        )}
        <Button
          titre={btnTitleModifyPassword}
          styleBtn={styleBtn}
          isLoading={isLoadingBtnForPaswword}
        />
      </form>
      {isPasswordModify && (
        <form onSubmit={handleSubmitPassword} className="p-3">
          {dataInfoFormInputPasswordModify.map((item, index) => (
            <InputInfo
              key={index}
              labelInput={item.labelInput}
              isForModifyOrNotModify={item.isForModifyOrNotModify}
              isApplyValueByDefault={item.isApplyValueByDefault}
              handleValue={item.handleValue}
              nameInput={item.nameInput}
              typeInput={item.typeInput}
              dataValue={item.dataValue}
              isDisabledInput={item.isDisabledInput}
            />
          ))}
          <Button
            titre={btnTitleModifyPassword}
            styleBtn={styleBtn}
            isLoading={isLoadingBtnForPaswword}
          />
        </form>
      )}
    </>
  );
}

const ShowGalerie = ({ galeries, deleteImageBiens, isDelete }) => {
  return (
    <>
      <label htmlFor="photos">Photos</label>
      <div
        className="d-flex justify-content-center 
           place-items-center gap-3 align-items-center flex-wrap">
        {galeries.map((rowData) => (
          <div className="conteneur_image_edition">
            {isDelete && (
              <AiFillDelete
                style={{
                  position: "absolute",
                  top: ".5em",
                  right: ".5em",
                  zIndex: 90,
                  color: "crimson",
                  cursor: "pointer",
                }}
                fontSize={"1.5em"}
                onClick={() => deleteImageBiens(rowData.id)}
              />
            )}
            <img
              src={lienImage + rowData?.path}
              className="position-absolute"
              alt={rowData?.path}
            />
          </div>
        ))}
      </div>
    </>
  );
};

const InputInfo = ({
  labelInput,
  typeInput,
  nameInput,
  isForModifyOrNotModify,
  isApplyValueByDefault,
  handleValue,
  dataValue,
  isDisabledInput,
}) => {
  return (
    <div className={typeInput !== "password" ? "col-lg-4" : "col-lg-6"}>
      <InputCreate
        label={labelInput}
        typeInput={typeInput}
        nameInput={nameInput}
        active={isForModifyOrNotModify}
        MydefaultValue={isApplyValueByDefault}
        getValue={handleValue}
        dataValue={dataValue}
        isDisabledInput={isDisabledInput}
      />
    </div>
  );
};

const SelectByOptionData = ({ dataInfoFormSelect }) => {
  return dataInfoFormSelect.map((select, index) => (
    <div key={index}>
      <label htmlFor={select.labelHtmlFor}>{select.label}</label>
      <select
        name={select.selectName}
        id={select.selectId}
        disabled={select.selectDisabled}
        defaultValue={Number(select.selectDefaultValue)}
        onChange={select.handleChangeSelect}
        className="w-100 p-3 mb-2">
        <option value={""} disabled selected>
          {select.optionFirstSelected}
        </option>

        {select.dataInfo.map((item) => (
          <option key={item.id} value={item.id}>
            {item.label || item.name}
          </option>
        ))}
      </select>
    </div>
  ));
};

const DataForTextArea = ({ dataTextArea }) => {
  return (
    <>
      {dataTextArea.length > 0 &&
        dataTextArea.map((element, index) => (
          <div key={index}>
            <label htmlFor={element.labelHtmlFor}> {element.label}</label>
            <textarea
              defaultValue={element.textAreaDefaultValue}
              onChange={element.handleTextAreaChange}
              disabled={element.isDisabledTextArea}
              name="description"
              id=""
              cols="30"
              rows="10"
              className="w-100"></textarea>
          </div>
        ))}
    </>
  );
};

const UploadImages = ({ fileList, onChangeForGalerie, onPreview }) => {
  return (
    <>
      <span className="my-3">Ajouter vos photos</span>
      <Upload
        listType="picture-card"
        fileList={fileList}
        onChange={onChangeForGalerie}
        onPreview={onPreview}
        multiple>
        {fileList.length < 5 && "+ Ajouter vos photos"}
      </Upload>
    </>
  );
};

export default FormShared;
